export default __webpack_public_path__ + "static/media/performance-by-standards.dbdb8785.png";